// address type strings
export const SENDER_ADDRESS_KIND = 'sender';

// address book names
export const RATE_AT_CHECKOUT_SENDER_ADDRESS_BOOK = 'rac-sender-address-book';
export const INTEGRATED_STORES = ['wix'];
